import { useTranslation } from "react-i18next"
import {
  Area,
  AreaChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts"

import type { UsageDailyPoint } from "../../types"

const USES_COLOR = "hsl(var(--chart-1))"
const EXPORTS_COLOR = "hsl(var(--chart-2))"

export function SlideUsageChart({ data }: { data: UsageDailyPoint[] }) {
  const { t } = useTranslation()
  const hasData = data.length > 0 && data.some((d) => d.uses > 0 || d.exports > 0)

  return (
    <div className="bg-card mb-6 rounded-lg border p-5 shadow-sm">
      <div className="mb-3 flex items-center justify-between">
        <h3 className="text-sm font-semibold">{t("slideSense.usage.chart.title")}</h3>
      </div>
      {hasData ? (
        <ResponsiveContainer height={280} width="100%">
          <AreaChart data={data} margin={{ top: 8, right: 8, bottom: 0, left: -12 }}>
            <CartesianGrid className="stroke-border" strokeDasharray="3 3" />
            <XAxis dataKey="date" tick={{ fontSize: 12 }} tickFormatter={(d) => d.slice(5)} />
            <YAxis allowDecimals={false} tick={{ fontSize: 12 }} />
            <Tooltip contentStyle={{ borderRadius: 8, fontSize: 12 }} />
            <Legend iconType="circle" wrapperStyle={{ fontSize: 12 }} />
            <Area
              dataKey="uses"
              fill={USES_COLOR}
              fillOpacity={0.18}
              name={t("slideSense.usage.chart.legendUses")}
              stroke={USES_COLOR}
              type="monotone"
            />
            <Area
              dataKey="exports"
              fill={EXPORTS_COLOR}
              fillOpacity={0.18}
              name={t("slideSense.usage.chart.legendExports")}
              stroke={EXPORTS_COLOR}
              type="monotone"
            />
          </AreaChart>
        </ResponsiveContainer>
      ) : (
        <div className="text-muted-foreground flex h-[240px] items-center justify-center text-sm">
          {t("slideSense.usage.chart.empty")}
        </div>
      )}
    </div>
  )
}
